import { useRef } from "react";

/* eslint-disable react-hooks/refs */

/** Remember the last {@link value} that was not `undefined` */
export function useLastDefined<T>(value: T | undefined): T | undefined {
    const lastValue = useRef<T | undefined>(value);
    if (value !== undefined) {
        lastValue.current = value;
        return value;
    }

    return lastValue.current;
}

/** Remember the last {@link value} that was not `null` or `undefined` */
export function useLastNonNull<T>(value: T | null | undefined): T | null | undefined {
    const lastValue = useRef<T | null>(value);
    if (value !== null && value !== undefined) {
        lastValue.current = value;
        return value;
    }
    return lastValue.current;
}
